<template>
    <div class="client_manage">
        <a-card :title="title" :bordered="false">

            <a-form :form="form" class="postage">

                <a-form-item label="模版名称" :label-col="{ span: 2 }" :wrapper-col="{ span: 16 }">
                    <a-input v-if="!see" style="width:400px;"
                             v-decorator="['name', { rules: [{ required: true, message: '请输入模版名称' }], initialValue: names }]"></a-input>
                    <p v-else>{{names}}</p>
                </a-form-item>

                <!-- <a-form-item label="计费类型" :label-col="{ span: 2 }" :wrapper-col="{ span: 16 }">

                  <a-radio-group v-model="value">
                    <a-radio value="0">按件计费</a-radio>
                    <a-radio value="1">按重计费</a-radio>
                  </a-radio-group>

                </a-form-item> -->

                <a-form-item label="运费规则" :label-col="{ span: 2 }" :wrapper-col="{ span: 14 }">
                    <a-button type="primary" v-if="!see" @click="onAddRule">添加规则</a-button>
                    <a-input type="hidden"
                             v-decorator="['ddd', { initialValue: '123',rules: [{ required: true}] }]"></a-input>
                    <a-table :columns="columns" :dataSource="tabls">
						<div slot="name" slot-scope="text, record" class="fname">
							{{text.name}}
						</div>
                        <span slot="action" slot-scope="text, record">
                          <a-button icon="delete" size="small" @click="onDelete(text)">删除</a-button>
                        </span>
                    </a-table>
                </a-form-item>

            </a-form>
			<div style="height: 68px;"></div>
            <div class="foot">
                <a-button type="danger" class="btns" @click="onGoBack">取消</a-button>
                <a-button type="primary" v-if="!see" @click="handleSubmit" :loading="loading">保存</a-button>
            </div>
        </a-card>


        <a-modal title="添加运费规则" v-model="visible" width="680px" @ok="handleOk" :confirmLoading="confirmLoading"
                 @cancel="initialize">


            <div class="boxs" style="margin-bottom: 20px;">
                <a-row>
                    <a-col :span="12"><span><span style="color:#FF3333">*</span>运费：</span>
                        <a-input type="number" v-model="freight" style="width:200px;"/>&nbsp;元
                    </a-col>
                </a-row>
            </div>

            <a-row>
                <a-col :span="24">
                    <div class="choice">
                        <div><span style="color:#FF3333">*</span>选择省份：</div>
                        <div>
                            <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                                <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange"
                                            :checked="checkAll">
                                    全选
                                </a-checkbox>
                            </div>
                            <br/>

                            <a-checkbox-group :options="provinces" v-model="checkedList" @change="onChange"/>

                        </div>
                    </div>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
    import {arrCopy} from '../../lib/tool'


    export default {
        data() {
            return {
                title: '编辑模板',
                visible: false,
                columns: [
                    {
                        title: '运费',
                        key: 'freight',
                        dataIndex: 'freight',
						width: 100,
                    },
                    {
                        title: '省份',
                        key: 'name',
                        scopedSlots: {customRender: 'name'},
						ellipsis: true,
                    },
                    {
                        title: '操作',
                        key: 'action',
                        scopedSlots: {customRender: 'action'},
						width: 100,
                    }
                ],
                form: this.$form.createForm(this, {name: 'postageadd'}),
                checkedList: [],
                indeterminate: true,
                checkAll: false,
                value: '0',
                freight: '',
                two: '10',
                three: '1',
                four: '10',
                name: '',
                province: [],
                provinces: [],
                tabls: [],
                confirmLoading: false,
                count: 0,
                loading: false,
                names: '',
                data: null,
                see: false,  //是否是查看
            }
        },
        watch: {
            value: function (val) {
                Object.assign(this, {
                    freight: '',
                    two: '',
                    three: '',
                    four: '',
                    name: ''
                })
            }
        },
        mounted() {
            if (this.$route.query.see) {
                this.see = this.$route.query.see
                this.title = '查看模板'
                this.columns.pop()
            }
            this.inits()
        },
        methods: {
            initialize(){
                Object.assign(this,{
                    checkedList:[],
                    indeterminate:false,
                    checkAll: false
                })
            },
            /**
             * @name 页面初始化
             */
            inits() {
                let {params} = this.$route
                this.$request.get('?module=pc_api&action=freight&m=edit_show', {params}).then(res => {
                    let {code, data, message} = res
                    if (code === 200) {

                        if (!(data.list instanceof Array)) {
                            data.list = Object.values(data.list)
                        }
                        console.log(data.freight)

                        Object.assign(this, {
                            tabls: data.freight,
                            value: data.type,
                            names: data.name,
                            data: data
                        })
                    }
                })
                console.log(this.tabls)

                this.$request.get('?module=pc_api&action=freight&m=get_sheng').then(res => {
                    let {code, message, data} = res
                    let arr = []

                    if (code === 200) {
                        for (let item of data) {
                            arr.push({label: item.G_CName, value: item.GroupID})
                        }
                        this.province = arr
                    }
                })
            },
            /**
             * @name 多选选中
             * */
            onChange(checkedList) {
                this.indeterminate = !!this.checkedList.length && this.checkedList.length < this.province.length
                this.checkAll = this.checkedList.length === this.province.length
            },
            /**
             * @name 全选选中
             * */
            onCheckAllChange(e) {
                // Object.assign(this, {
                //     checkedList: e.target.checked ? this.province : [],
                //     indeterminate: false,
                //     checkAll: e.target.checked,
                // });
                Object.assign(this, {
                    checkedList: e.target.checked ? Array.from(this.provinces,item => item.value) : [],
                    indeterminate: false,
                    checkAll: e.target.checked,
                });
            },
            /**
             * @name 打开添加规则窗口
             * */
            onAddRule() {
                let province = arrCopy(this.province)
                for(let item of this.tabls){
                    province = province.filter(items => item.name.includes(items.label) === false)
                }

                province = province.filter(word => word != undefined);
                if(province.length == 0){
                    this.visible = false
                    this.$message.warning('所有省份均已设置了运费！')
                    return
                }
                this.visible = !this.visible
                this.provinces = province
                // console.log(province)
            },
            /**
             * @name 返回
             * */
            onGoBack() {
                this.$router.go(-1)
            },
            /**
             * @name 添加运费规则
             * */
            handleOk() {
                if (this.freight == '') {
                    this.$message.warning('请输入运费！');
                    return
                }

                this.confirmLoading = true
                let checkedList = this.checkedList
                let province = this.province
                let arr = []

                if (checkedList.length) {


                    for (let i of checkedList) {
                        for (let t of province) {
                            if (t.value === i) {
                                arr.push(t.label)
                            }
                        }
                    }

                    this.tabls.push({
                        key: this.count++,
                        freight: this.freight,
                        // two: this.two,
                        // three: this.three,
                     // four: this.four,
                        name: arr.join(',')
                    })

                    // 初始化
                    Object.assign(this, {
                        freight: '',
                        // two:'10',
                        // three:'1',
                        // four:'10',
                        name: ''
                    })


                    setTimeout(() => {
                        // this.onAddRule()
                        this.visible = false
                        this.checkedList = []
                        this.confirmLoading = false

                        Object.assign(this,{
                            checkedList:[],
                            indeterminate:false,
                            checkAll: false
                        })
                    }, 600)
                    return
                }

                this.$message.warning('请选择省份！');
                setTimeout(() => {
                    this.confirmLoading = false
                }, 600)
            },
            /**
             * @name 表格操作
             */
            onDelete(record) {
                let name = record.name
                let tabls = this.tabls
                for (let i in this.tabls) {
                    if (tabls[i].name === name) {
                        this.tabls.splice(i, 1)
                    }
                }
            },
            /**
             * @name 保存表单验证
             * */
            handleSubmit() {
                this.loading = true
                this.form.validateFields((err, values) => {

                    if (!err) {
                        let data = {
                            id: this.data.id,
                            ...values,
                            type: this.value,
                            hidden_freight: this.tabls
                        }
                        this.httpUpdate(data)

                        return
                    }

                    setTimeout(() => {
                        this.loading = false
                    }, 600)
                })
            },
            /**
             * @name 修改数据
             * */
            httpUpdate(data) {


                this.$request.post('?module=pc_api&action=freight&m=edit', data).then(res => {
                    let {code, message, data} = res

                    if (code === 200) {
                        this.$message.success(message)

                        setTimeout(() => {
                            this.onGoBack()
                        }, 600)
                        return
                    }


                    this.$message.warning(message)
                    setTimeout(() => {
                        this.loading = false
                    }, 600)
                })
            }
        }
    }
</script>

<style lang="less" scoped>

    .ant-checkbox-group {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-row-gap: 10px;
    }
    
    .client_manage {
      display: flex;
      flex-direction: column;
      height: 100%;
      
      .ant-card{
    	  display: flex;
    	  flex-direction: column;
    	  
    	  /deep/.ant-card-body{
    		  flex: 1;
    		  overflow: hidden auto;
    	  }
      }
      
      .search {
        padding: 8px 32px;
      }
    
      .handle {
        padding: 0px 32px;
        padding-bottom: 8px;
        display: flex;
        align-items: center;
      }
    
      .postage {
        margin-top: 43px;
      }
      
      .foot {
        height: 68px;
        width: 100%;
        border-top: 1px solid #E9ECEF;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0px 60px;
    	background-color: #FFFFFF;
    
        .btns {
          margin-right: 10px;
        }
      }
    }
    .choice {
      display: flex;
    }
    
    .box{
      height: 86px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      font-size: 14px;
      color: #323544;
    }

</style>